import {userPrefs} from '@netx/core-user/collections/singletons/userPreferences';

export const getPreference = <Bool extends boolean = false>(
	key: string,
	asBoolean?: Bool,
) => {
	return userPrefs[asBoolean ? 'isTrue' : 'getPreference'](
		key,
	) as Bool extends true ? boolean : string | undefined;
};

export default getPreference;
